module.exports = __webpack_public_path__ + "img/카발리어.6dffced9.png";